import React, { useState, useEffect } from "react";
// import ReactIdSwiper from "react-id-swiper/lib/ReactIdSwiper.custom";
import ReactIdSwiper from "react-id-swiper";
// import {
//   Swiper,
//   Navigation
// } from "swiper/dist/js/swiper.esm";
import generateData from "./data";
import SlideItem from "./slideItem";

export default () => {
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  // Params definition
  const params = {
    slidesPerView: 4,
    centeredSlides: true,
    spaceBetween: 40,
    loop: true,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 1,
      stretch: 0,
      depth: 110,
      modifier: 1,
      slideShadows: false
    },
    getSwiper: updateSwiper // Get swiper instance callback
  };

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const renderItem = ({ kick, idx }) => (
    <SlideItem kick={kick} key={idx} />
  );

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {generateData().map(renderItem)}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev}>
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext}>
          Next
        </button>
      </div>
    </div>
  );
};
